import ActionButton from '../components/ActionButton/index';
import SectionTitle from '../components/PageTitle';
import React from 'react';
import {Banner, GridLayout} from './styles';
import {ContentContainer} from '../Landing/styles';
import {assetUrl} from '../Landing';

const ToolBanners = () => (
	<ContentContainer>
		<SectionTitle light={false} id="tim-viec-thong-minh">Tìm việc thông minh</SectionTitle>
		<GridLayout>
			<Banner className="top-banner" style={{backgroundImage: `url(${assetUrl('bg_wow_cv.jpg')})`}}>
				<div className="content">
					<img src={assetUrl('wow_cv.png')}/>
					<ActionButton href="https://www.vietnamworks.com/wowcv" target="_blank">Truy cập ngay</ActionButton>
				</div>
			</Banner>
			<Banner style={{backgroundImage: `url(${assetUrl('banner_cau_hoi_phong_van.jpg')})`}}>
				<div className="content">
					<span className="title">
						Bộ câu hỏi phỏng vấn
					</span>
					<ActionButton href="https://www.vietnamworks.com/cau-hoi-phong-van/tat-ca-viec-lam" target="_blank">Truy cập ngay</ActionButton>
				</div>
			</Banner>
			<Banner style={{backgroundImage: `url(${assetUrl('banner_tra_cuu_muc_luong.jpg')})`}}>
				<div className="content">
					<span className="title dark">
						tra cứu mức lương
					</span>
					<ActionButton href="https://www.vietnamworks.com/muc-luong/tat-ca-viec-lam" target="_blank">Truy cập ngay</ActionButton>
				</div>
			</Banner>
			<Banner style={{backgroundImage: `url(${assetUrl('banner_cong_cu_tinh_luong.jpg')})`}}>
				<div className="content">
					<span className="title">
						Công cụ tính lương
					</span>
					<ActionButton href="https://www.vietnamworks.com/tinh-luong-gross-net" target="_blank">Truy cập ngay</ActionButton>
				</div>
			</Banner>
		</GridLayout>
	</ContentContainer>
)

export default ToolBanners
